import React, { useState, useRef, useEffect, useContext } from "react";
import { FormValidate } from '../../common'
import { Input, Icon, } from 'semantic-ui-react'
import { useHistory, NavLink } from "react-router-dom";
import "./Login.scss";
import logo from "../../assets/home/atar_logo.png";
import { StarButton } from '../../components'
import { useSelector, useDispatch } from 'react-redux'
import { referralValidate } from '../../store/AuthRedux'
import { useTranslation } from "react-i18next";

const Referral = () => {
    const dispatch = useDispatch()
    const token = useSelector((state) => state.auth.token)
    const isFetching = useSelector((state) => state.auth.isFetching)
    const isReferralSend = useSelector((state) => state.auth.isReferralSend)
    const loginRedirectUrl = useSelector((state) => state.auth.loginRedirectUrl)
    const { t, i18n } = useTranslation();
    const pageActive = useRef(false);
    const refInput = useRef(null);
    const history = useHistory();
    const [referalCode, setReferalCode] = useState('')
    const [errorRef, setErrorRef] = useState(null)
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    const getReferral = () => {
        if (!referalCode) {
            setErrorRef('Please enter referal code')
            refInput.current.focus();
            return
        }
        let params = { referalCode, token }
        pageActive.current = true;
        dispatch(referralValidate(params))
    }


    useEffect(() => {
        if (isReferralSend && pageActive.current) {
            goToMenu()
        }
    }, [isReferralSend]);

    const goToMenu = () => {
        if (loginRedirectUrl) {
            history.push(`/${loginRedirectUrl}`);
        } else {
            history.push("/");
        }
    };

    return (
        <>
            <div className="container-fluid home clearall">
                <div className="bg">
                    <div className="img_sec">
                        <div className="singup_sec">
                            <div className="singup">
                                <NavLink
                                    to="">
                                    <img className="login_logo" src={logo} />
                                </NavLink>
                                <div className="dream_sec">
                                    <div className="innerdream_sec">
                                        {errorRef ? <div className="login_error">{errorRef}</div> : ''}
                                        <h3>REFERRAL CODE</h3>
                                        <div className="account_sec">
                                            <div className="already">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                                        </div>

                                        <div className="input-group mb-3">
                                            <Input fluid className={"fast_input  center " + (errorRef ? "inputError" : '')}>
                                                <input
                                                    ref={refInput}
                                                    placeholder='Enter the referal code here'
                                                    type="text"
                                                    value={referalCode}
                                                    onChange={(obj) => {
                                                        if (obj.target.value.length === 11) return false;
                                                        setReferalCode(obj.target.value);
                                                        setErrorRef(null)
                                                    }}
                                                />
                                            </Input>
                                        </div>

                                        <div style={{ marginTop: "29px", position: "relative" }}>
                                            <StarButton background={'mainBg'} width="100%" isLoading={isFetching} title="Proceed" onClickAction={() => getReferral()} disableStar={referalCode.length > 0 ? false : true} isGray={referalCode.length > 0 ? false : true} />
                                        </div>
                                        <div className="skipMenu"><span onClick={() => goToMenu()}>Skip</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Referral